module.exports = __webpack_public_path__ + "img/img-146.c2df8cb2.png";